var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_vm._v("\n\tA new public deal at "),_c('DealComponent',{attrs:{"notification":_vm.notification}}),_vm._v(" was added by "),_c('UserComponent',{attrs:{"notification":_vm.notification}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }